export const CHARGE_OVERDUE = "Overdue";
export const CHARGE_DUE = "Due Now";
export const CHARGE_NOT_DUE = "Not Yet Due";
export const CHARGE_PAID = "Paid";
